import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_CREDIT_NOTES_CPE = '[CPE] GET CREDIT NOTES CPE'
export const SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT = '[CPE] SEND UNINFORMED CREDIT NOTES TO SUNAT'
export const SEND_CREDIT_NOTE_TO_SUNAT = '[CPE] SEND CREDIT NOTE TO SUNAT'

export function getCreditNotesCPEAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/credit-notes-cpe/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_CREDIT_NOTES_CPE, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CREDIT_NOTES_CPE, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_CREDIT_NOTES_CPE, error)
    }).finally(() => {
      dispatch({ type: GET_CREDIT_NOTES_CPE, payload: { loading: false } })
    })
  }
}

export function sendUninformedCreditNotesToSunatAction() {
  const request = api.post(`/credit-notes-cpe/send-uninformed-to-sunat`)
  return (dispatch) => {
    dispatch({ type: SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT, payload: { sending: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      toast.success(response.data.message)
      dispatch({ type: SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_UNINFORMED_CREDIT_NOTES_TO_SUNAT, payload: { sending: false } })
    })
  }
}

export function sendCreditNoteToSunatAction(creditNoteId) {
  const request = api.post(`/credit-note-cpe/send-to-sunat/${creditNoteId}`)
  return (dispatch) => {
    dispatch({ type: SEND_CREDIT_NOTE_TO_SUNAT, payload: { sending_id: creditNoteId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SEND_CREDIT_NOTE_TO_SUNAT, payload: { sent_id: creditNoteId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SEND_CREDIT_NOTE_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_CREDIT_NOTE_TO_SUNAT, payload: { sending_id: creditNoteId } })
    })
  }
}

export function checkIfCreditNoteWasSentToSunatAction(creditNoteId) {
  const request = api.get(`/credit-note-cpe/check-sent/${creditNoteId}`)
  request.then((response) => {
    if (Number(response.data.status) !== 200) {
      toast.error(response.data.message)
      return
    }
    toast.success(response.data.message)
  }).catch((error) => {
    console.log(error)
  })
}
